    <template>
      <div class="card mb-25 border-0 rounded-0 bg-white add-matiere-card">
        <div class="card-header">
          <h3 class="text-black fw-semibold">Ajouter un étudiant</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="etudiantForm" @submit="addEtudiant" :validation-schema="etudiantSchema">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Numéro Matricule <span class="text-danger">*</span>
                  </label>
                  <Field name="numeroMatricule" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le numéro" />
                  <ErrorMessage name="numeroMatricule" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom <span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nom" />
                  <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Prénom <span class="text-danger">*</span>
                  </label>
                  <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le prenom" />
                  <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Email <span class="text-danger">*</span>
                  </label>
                  <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'email" />
                  <ErrorMessage name="email" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Sexe <span class="text-danger">*</span>
                  </label>
                  <Field name="sexe" type="text" v-slot="{ field }">
                    <Multiselect :searchable="true" :options="['Masculin', 'Féminin']" v-model="field.value"
                      v-bind="field" placeholder="Sélectionner le sexe" />
                  </Field>
                  <ErrorMessage name="sexe" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone 1
                  </label>
                  <Field name="telephone1" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                      defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2">
                    </vue-tel-input>
                  </Field>
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
                  <!-- <Field name="telephone1" type="text" 
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le téléphone"/> -->
                  <ErrorMessage name="telephone1" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Catégorie d'étudiant <span class="text-danger">*</span>
                  </label>
                  <Field name="categorieEtudiant" type="text" v-slot="{ field }">
                    <Multiselect :searchable="true" :options="['Habitué', 'Auditeur','Disciple','Apprenant']" v-model="field.value"
                      v-bind="field" placeholder="Sélectionner la catégorie" />
                  </Field>
                  <ErrorMessage name="categorieEtudiant" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Formateur ? <span class="text-danger"></span>
                  </label>
                  <Field name="categorieFormateur" type="text" v-slot="{ field }">
                    <Multiselect :searchable="true" :options="['Tutorat', 'Animateur']" v-model="field.value"
                      v-bind="field" placeholder="Sélectionner la catégorie" />
                  </Field>
                  <ErrorMessage name="categorieFormateur" class="text-danger" />
                </div>
              </div>


              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de naissance <span class="text-danger">*</span>
                  </label>
                  <Field name="dateNaissance" type="date" :max="currentDate"
                    class="form-control shadow-none fs-md-15 text-black" />
                </div>
                <ErrorMessage name="dateNaissance" class="text-danger" />
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Pays de naissance
                    <span class="text-danger">*</span>
                  </label>
                  <Field name="nationalite" v-model="nationalite" v-slot="{ field }">
                    <Multiselect :options="countries" :searchable="true" track-by="value" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner le pays de résidence" />
                  </Field>

                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Commune
                  </label>
                  <Field name="commune" v-model="commune" v-slot="{ field }">
                    <Multiselect :options="communeOptions" @change="communeChange($event)" :searchable="true"
                      track-by="label" label="label" v-model="selectedCommune" v-bind="field"
                      placeholder="Sélectionner la commune" />
                  </Field>
                  <ErrorMessage name="commune" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Quartier
                  </label>
                  <Field name="quartier" v-model="quartier" v-slot="{ field }">
                    <Multiselect :options="quartierOptions" :searchable="true" track-by="label" label="label"
                      v-model="selectedQuartier" v-bind="field" noOptionsText="Sélectionner d'abord une commune"
                      placeholder="Sélectionner le quartier" />
                  </Field>
                  <ErrorMessage name="quartier" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="ecoleProvenance" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Nombre d'années d'expériences
                  </label>
                  <Field name="anneeExperience" type="number"
                    class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer le nombre" />
                  <ErrorMessage name="anneeExperience" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Qualification <span class="text-danger">*</span>
                  </label>
                  <Field name="qualification" v-slot="{ field }">
                    <Multiselect :options="qualificationOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner la qualification" />
                  </Field>
                </div>
                <ErrorMessage name="qualification" class="text-danger" />
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Activité <span class="text-danger">*</span>
                  </label>
                  <Field name="activites" v-slot="{ field }">
                    <Multiselect :options="activiteOptions" :searchable="true" mode="tags" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
                  </Field>
                </div>
                <ErrorMessage name="activites" class="text-danger" />
              </div>

                <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Langue <span class="text-danger">*</span>
                  </label>
                  <Field name="langues" v-slot="{ field }">
                    <Multiselect :options="languesOptions" :searchable="true" mode="tags" track-by="label"
                      label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner les langues" />
                  </Field>
                </div>
                <ErrorMessage name="langues" class="text-danger" />
              </div>
              <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Poste occupé actuellement
              </label>
              <Field name="poste" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le poste" />
              <ErrorMessage name="poste" class="text-danger" />
            </div>
          </div>
<div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Catégorie Profesionnelle
              </label>
              <Field name="categorie" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer la categorie" />
              <ErrorMessage name="categorie" class="text-danger" />
            </div>
          </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Informations complémentaires
                  </label>
                  <Field name="biographie" rows="2" as="textarea" placeholder="Ajouter d'autres informations"
                    v-slot="{ field }" class="form-control shadow-none rounded-0 text-black">
                    <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
                  </Field>
                  <ErrorMessage name="biographie" class="text-danger" />
                </div>
              </div>
              <div class="row">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                    <div class="row">
                      <div class="border border-primary mb-1">
                        <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                          style="background-color: #0a59a4">
                          <div class="col-md-7">
                            <h3 class="fs-4 text-white">Pièce(s)</h3>
                          </div>
                          <div class="col-md-5">
                            <div class="d-flex float-end">
                              <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                                type="button" :class="{ 'cursor-not-allowed': isDisable }" @click="addRowPiece()">
                                <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                                Ajouter une pièce
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <!-- Titres colonnes -->
                          <div class="row gx-1">
                            <div class="col-md-4">
                              <label class="d-block text-black fw-semibold">
                                Type de pièce
                              </label>
                            </div>
                            <div class="col-md-4">
                              <label class="d-block text-black fw-semibold mb-1">
                                Numéro de pièce
                              </label>
                            </div>
                            <div class="col-md-3">
                              <label class="d-block text-black fw-semibold mb-1">
                                Image
                              </label>
                            </div>
                            <div class="col-md-1">
                              <label class="d-block text-black fw-semibold mb-1">
                                Action
                              </label>
                            </div>
                          </div>
                          <hr class="mt-0" />
                          <!-- Boucle sur les pièces -->
                          <div class="row gx-1" v-for="(piece, index) in pieces" :key="index">
                            <!-- Type de pièce -->
                            <div class="col-md-4 mb-3">
                              <div class="modern-select-group">
                                <Field :name="`pieces[${index}].typePiece`" v-slot="{ field }">
                                  <Multiselect v-model="pieces[index].typePiece" v-bind="field" :options="typeOptions"
                                    :preserve-search="true" :multiple="false" :searchable="true"
                                    placeholder="Sélectionner le type de pièce" label="label" track-by="value"
                                    value-prop="value" class="modern-multiselect" />
                                </Field>
                                <ErrorMessage :name="`pieces[${index}].typePiece`" class="text-danger" />
                              </div>
                            </div>

                            <!-- Numéro de pièce (conditionnel) -->
                            <div class="col-md-4 mb-3" v-if="!isPhotoPiece(pieces[index].typePiece)">
                              <!-- Change 'photo' selon ton libellé -->
                              <div class="modern-input-group">
                                <Field type="text" class="form-control shadow-none fs-md-15 text-black modern-input"
                                  placeholder="Entrer le numéro de la pièce" :name="`pieces[${index}].numeroPiece`"
                                  v-model="pieces[index].numeroPiece" />
                                <ErrorMessage :name="`pieces[${index}].numeroPiece`" class="text-danger" />
                              </div>
                            </div>

                            <!-- Optionnel : message si c'est une photo -->
                            <div class="col-md-4 mb-3" v-else>
                              <small class="text-muted">Aucun numéro requis pour la photo d'identité</small>
                            </div>
                            <!-- Numéro de pièce -->
                            <!--  <div class="col-md-4 mb-3">
                              <div class="modern-input-group">
                                <Field type="text" class="form-control shadow-none fs-md-15 text-black modern-input"
                                  placeholder="Entrer le numéro de la pièce" :name="`pieces[${index}].numeroPiece`"
                                  v-model="pieces[index].numeroPiece" />

                                <ErrorMessage :name="`pieces[${index}].numeroPiece`" class="text-danger" />
                              </div>
                            </div>-->

                            <!-- Image -->
                            <div class="col-md-3 mb-3">
                              <div class="form-group mb-0">
                                <Field type="file" accept="image/*" class="form-control"
                                  @change="handleFileChange($event, index)" :name="`pieces[${index}].urlImage`" />

                                <ErrorMessage :name="`pieces[${index}].urlImage`" class="text-danger" />
                              </div>
                            </div>
                            <!-- Bouton suppression -->
                            <div class="col-md-1 mb-3" v-if="index > 0">
                              <button class="btn btn-danger transition border-0 py-1 px-2" type="button"
                                @click="removeRowPiece(index)">
                                <i class="flaticon-delete lh-1 me-0 position-relative top-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-3">
                <div class="d-flex align-items-center ">
                  <button ref="submitButton" class="btn btn-success me-3" type="submit" :disabled="isSubmitting">
                    <i v-if="!isSubmitting" class="fa fa-plus me-2"></i>
                    <i v-if="isSubmitting" class="fa fa-spinner fa-spin me-2"></i>
                    {{ isSubmitting ? 'Enregistrement...' : 'Ajouter un etudiant' }}
                  </button>
                  <router-link to="/liste-etudiants" class=" btn btn-danger"><i
                      class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler</router-link>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage, FormContext } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import { VueTelInput } from 'vue3-tel-input';
import axios from 'axios';
import { countries } from "../../components/Inscription/countries";

export default defineComponent({
  name: "AddEtudiant",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    VueTelInput
  },
  setup() {
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const typeOptions = ref([]);
    const qualificationOptions = ref([]);
    const activiteOptions = ref([]);
    const quartierOptions = ref([]);
    const communeOptions = ref([]);
    const languesOptions = ref([]);
    const selectedCommune = ref<number | null>(null);
    const selectedQuartier = ref<number | null>(null);
    const nationalite = ref("Bénin");

    const isSubmitting = ref(false);
    const isDisable = ref(false);           // Changé à false pour plus de flexibilité
    const etudiantForm = ref<FormContext | null>(null);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const router = useRouter();

    const telephone1 = ref('');
    const validPhone = ref(true);

    const pieces = ref<any[]>([{ 
      typePiece: '', 
      numeroPiece: '', 
      urlImage: null 
    }]);

    // ====================== SCHEMA DE VALIDATION ======================
    const etudiantSchema = Yup.object().shape({
      numeroMatricule: Yup.string().required('Le numéro matricule est obligatoire'),
      nom: Yup.string().required('Le nom est obligatoire'),
      prenom: Yup.string().required('Le prénom est obligatoire'),
      sexe: Yup.string().required('Le sexe est obligatoire'),
      email: Yup.string().email('Email invalide').notRequired(),
      categorieEtudiant: Yup.string().required('La catégorie d\'étudiant est obligatoire'),
      qualification: Yup.string().required('La qualification est obligatoire'),
      activites: Yup.array().of(Yup.string()).min(1, 'Au moins une activité est obligatoire'),
      langues: Yup.array().of(Yup.string()).min(1, 'Au moins une famille est obligatoire'),
      nationalite: Yup.string().required('La nationalité est obligatoire'),
      dateNaissance: Yup.date()
        .required('La date de naissance est obligatoire')
        .max(new Date(), 'La date ne peut pas être dans le futur')
        .test('age-minimum', 'L\'étudiant doit avoir au moins 18 ans', (value) => {
          if (!value) return false;
          const today = new Date();
          const birth = new Date(value);
          let age = today.getFullYear() - birth.getFullYear();
          const monthDiff = today.getMonth() - birth.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age--;
          return age >= 18;
        }),
      
      // Pièces complètement optionnelles
      pieces: Yup.array().of(
        Yup.object().shape({
          typePiece: Yup.string().notRequired(),
          numeroPiece: Yup.string().notRequired(),
          urlImage: Yup.mixed().notRequired(),
        })
      ).notRequired(),
    });

    // ====================== FONCTIONS ======================
    const validatePhone = (phoneObject: any) => {
      validPhone.value = phoneObject.valid ?? false;
      if (phoneObject.valid) {
        telephone1.value = phoneObject.number;
      } else {
        telephone1.value = '';
      }
    };

    const isPhotoPiece = (typeId: string | number) => {
      return String(typeId) === '5' || String(typeId) === '9';
    };

    const addRowPiece = async () => {
      pieces.value.push({ typePiece: '', numeroPiece: '', urlImage: null });
    };

    const removeRowPiece = (index: number) => {
      if (pieces.value.length > 1) {
        pieces.value.splice(index, 1);
      }
    };

    const handleFileChange = (event: Event, index: number) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        pieces.value[index].urlImage = file;
      }
    };

    // ====================== ADD ETUDIANT ======================
    const addEtudiant = async (values: any, { resetForm }: any) => {
      if (submitButton.value) submitButton.value.disabled = true;
      isSubmitting.value = true;

      try {
        const formData = new FormData();

        // Champs principaux
        formData.append('numeroMatricule', values.numeroMatricule);
        formData.append('nom', values.nom);
        formData.append('prenom', values.prenom);
        formData.append('sexe', values.sexe);
        formData.append('email', values.email || '');
        formData.append('telephone1', telephone1.value || '');
        formData.append('dateNaissance', values.dateNaissance);
        formData.append('categorieEtudiant', values.categorieEtudiant);
        formData.append('categorieFormateur', values.categorieFormateur || '');
        formData.append('categorie', values.categorie || '');
        formData.append('poste', values.poste || '');
        formData.append('biographie', values.biographie || '');
        formData.append('nationalite', values.nationalite);
        formData.append('anneeExperience', values.anneeExperience?.toString() || '0');
        formData.append('qualificationId', values.qualification);

        if (selectedQuartier.value) {
          formData.append('quartier', selectedQuartier.value.toString());
        }

        // Activités
        if (Array.isArray(values.activites) && values.activites.length > 0) {
          values.activites.forEach((id: any) => formData.append('activites[]', id.toString()));
        }

        // Langues
        if (Array.isArray(values.langues) && values.langues.length > 0) {
          values.langues.forEach((id: any) => formData.append('langues[]', id.toString()));
        }

        // ====================== PIÈCES (OPTIONNELLES) ======================
        const validPieces = pieces.value.filter((p: any) => 
          p.typePiece && p.urlImage instanceof File
        );

        if (validPieces.length > 0) {
          const piecesData = validPieces.map((p: any) => ({
            typePiece: p.typePiece,
            numeroPiece: p.numeroPiece || null,
          }));

          formData.append('piecesData', JSON.stringify(piecesData));

          validPieces.forEach((p: any) => {
            if (p.urlImage instanceof File) {
              formData.append('piecesFichiers', p.urlImage);
            }
          });
        }

        const response = await ApiService.post('/etudiants', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.status === 201 || response.data?.code === 201) {
          success('Étudiant ajouté avec succès');
          resetForm();
          pieces.value = [{ typePiece: '', numeroPiece: '', urlImage: null }];
          router.push({ name: 'ListeEtudiantPage' });
        }

      } catch (err: any) {
        console.error('Erreur création étudiant:', err);
        const msg = err.response?.data?.message || err.message || 'Erreur lors de l\'ajout';
        error(msg);
      } finally {
        isSubmitting.value = false;
        if (submitButton.value) submitButton.value.disabled = false;
      }
    };

    // ====================== ON MOUNTED ======================
    onMounted(async () => {
      try {
        const [communesRes, languesRes, qualifRes, activiteRes, typesRes] = await Promise.all([
          ApiService.get("/communes"),
          axios.get('/langues'),
          ApiService.get('/all/qualifications'),
          axios.get('/all/activites'),
          ApiService.get('/all/typePieces')
        ]);

        communeOptions.value = communesRes.data.data.data.map((item: any) => ({
          value: item.id, label: item.libelle
        }));

        languesOptions.value = languesRes.data.data.data.map((l: any) => ({
          value: l.id, label: l.libelle
        }));

        qualificationOptions.value = qualifRes.data.data.data.map((q: any) => ({
          value: q.id, label: q.libelle
        }));

        activiteOptions.value = activiteRes.data.data.data.map((a: any) => ({
          value: a.id, label: a.libelle
        }));

        typeOptions.value = typesRes.data.data.data.map((t: any) => ({
          value: t.id.toString(), label: t.libelle
        }));
      } catch (err) {
        console.error("Erreur chargement données :", err);
      }
    });

    // Watch simplifié
    watch(pieces, () => {
      // On désactive le bouton "Ajouter une pièce" seulement si la dernière pièce est vide
      const last = pieces.value[pieces.value.length - 1];
      isDisable.value = !last.typePiece || !last.urlImage;
    }, { deep: true });

    return {
      etudiantSchema,
      addEtudiant,
      etudiantForm,
      submitButton,
      qualificationOptions,
      activiteOptions,
      currentDate,
      nationalite,
      validPhone,
      validate: validatePhone,
      quartierOptions,
      communeOptions,
      addRowPiece,
      pieces,
      removeRowPiece,
      handleFileChange,
      isDisable,
      typeOptions,
      communeChange: (value: number | null) => {
        selectedQuartier.value = null;
        if (value) {
          ApiService.get(`/communes/quartiers/${value}`).then(({ data }) => {
            quartierOptions.value = data.data.map((q: any) => ({
              value: q.id, label: q.libelle
            }));
          });
        } else {
          quartierOptions.value = [];
        }
      },
      isPhotoPiece,
      languesOptions,
      selectedCommune,
      selectedQuartier,
      isSubmitting, countries,
    };
  },
});
</script>
<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}
</style>
